import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate', pure: false })
export class TruncatePipe implements PipeTransform {
    public transform(value: any, args: string, args2: string): string {
        // args : truncate for string
        // args2 : truncate for number
        let trail = '...';
        if (typeof (value) === 'string') {
            let limit = parseInt(args);
            return value.length > limit ? value.substring(0, limit) + trail : value;
        }
        else if (typeof (value) === 'number') {
            value = value.toString();
            let limit = parseInt(args2, 10);
            return value.length > limit ? value.substring(0, limit) + trail : value;
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/pipes/truncate.pipe.ts